import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BankAccountSelector = ({ selectedAccount, onAccountChange, accounts }) => {
  const accountOptions = accounts?.map(account => ({
    value: account?.id,
    label: `${account?.name} - ${account?.accountNumber}`,
    description: `Balance: ${account?.balance}`
  }));

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-md flex items-center justify-center">
          <Icon name="Landmark" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg">Bank Account</h3>
          <p className="caption text-muted-foreground">Select account to reconcile</p>
        </div>
      </div>
      
      <Select
        label="Account"
        options={accountOptions}
        value={selectedAccount}
        onChange={onAccountChange}
        placeholder="Choose bank account"
        searchable
        required
      />
    </div>
  );
};

export default BankAccountSelector;